import { useAuthStore, useUIStore } from '@/stores';
import { Button } from '@/components/ui';
import { LogOut, Menu, Plus, List, ShoppingBag } from 'lucide-react';
import { TemplateShopModal } from './TemplateShopModal';

export function Navbar() {
  const { user, logout } = useAuthStore();
  const { toggleSidebar, openProjectModal, openProjectListModal, openTemplateShopModal, isTemplateShopModalOpen, closeTemplateShopModal } = useUIStore();

  const handleLogout = async () => {
    await logout();
    window.location.reload();
  };

  return (
    <>
      <nav className="bg-white shadow-md px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleSidebar}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Menu className="w-5 h-5 text-gray-600" />
          </button>
          <h1 className="text-xl font-bold text-gray-800">Project Timing</h1>
        </div>

        <div className="flex items-center space-x-3">
          <Button
            variant="ghost"
            size="sm"
            leftIcon={<Plus className="w-4 h-4" />}
            onClick={openProjectModal}
          >
            New Project
          </Button>

          <Button
            variant="ghost"
            size="sm"
            leftIcon={<List className="w-4 h-4" />}
            onClick={openProjectListModal}
          >
            Project List
          </Button>

          <Button
            variant="ghost"
            size="sm"
            leftIcon={<ShoppingBag className="w-4 h-4" />}
            onClick={openTemplateShopModal}
          >
            Template Shop
          </Button>

          <div className="h-6 w-px bg-gray-300 mx-2" />

          <span className="text-sm text-gray-600">{user?.email}</span>

          <button
            onClick={handleLogout}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            title="Logout"
          >
            <LogOut className="w-4 h-4 text-gray-600" />
          </button>
        </div>
      </nav>

      {/* Template Shop Modal */}
      <TemplateShopModal
        isOpen={isTemplateShopModalOpen}
        onClose={closeTemplateShopModal}
      />
    </>
  );
}
